module.exports = __webpack_public_path__ + "img/facebook.73805bf1.svg";